export const RoutesString = {
	Home: "/",
	About: "/about",
	Consulting: "/consulting",
	Project: "/project",
	Contact: "/contact"
};
